import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { LoadingService } from '@core/services/loading.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-social-links',
  templateUrl: './social-links.component.html',
  styleUrls: ['./social-links.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SocialLinksComponent implements OnInit {
  public arrCoupons: any[] = [];
 selectedUrl: string = '';

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router, 
    private toastr : ToastrService, 
    private loading: LoadingService,
        private modal : NgbModal, 
        private language : LanguageService,
         private route: ActivatedRoute,
           private modalService: NgbModal

  ) {} 

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;
  public userData : any

 
  public levels: any[] = [];
  public tempData = [];
  public fakeUsers:any

  public lang : any
public showSuccessAfterLoad = false;

  @ViewChild(DatatableComponent) table: DatatableComponent;

 

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {
    this.language.currentLang.subscribe((res: string) => {
      this.lang = res;
    })
    // this.fakeUsersList()


    
      this.route.queryParams.subscribe(params => {
    if (params['success'] === 'true') {
      this.showSuccessAfterLoad = true;

      // Remove the success param immediately
      this.router.navigate([], {
        queryParams: { success: null },
        queryParamsHandling: 'merge',
        replaceUrl: true // to prevent navigation history
      });
    }

    this.fakeUsersList(); // 🔁 move inside the queryParams logic to ensure order
  });
  }

      /*----------  Translating genders  ----------*/
  translateGender(gender) {
    if (gender == 'Male') {
      return 'ذكر';
    } else {
      return 'أنثى';
    }
  }
 
fakeUsersList() {
  this.loading.show();
  this.apisService.getSocialLinks().subscribe({
    next: (res) => {
      this.fakeUsers = res.data;
      this.loading.hide();

      // ✅ Only show SweetAlert AFTER loader is hidden
      if (this.showSuccessAfterLoad) {
        this.showSuccessAfterLoad = false; // reset the flag
        setTimeout(() => {
          Swal.fire(
            'تم بنجاح',
            'تم حفظ المستخدم الوهمي بنجاح',
            'success'
          );
        }, 100); // slight delay to ensure hide animation completes
      }
    },
    error: (err) => {
      console.log('error in fetching', err);
      this.loading.hide();
    }
  });
}


  
  /*----------  Handling image Error  ----------*/
  handleImageError(event) {
    event.target.src = 'assets/images/icons/logo.jpg';
  }

  

  
  /*----------  detele fake users  ----------*/
  deleteFakeUser(id){
    this.apisService.deleteSocialLinks(id).subscribe({
      next: (res) => {
        this.fakeUsersList()
        this.toastr.success("Deleted Successfully", "Success")
      },
      error: (err) => {
        console.log('error in fetching', err)
        this.toastr.error("Something went wrong", "Error")
      }
    })
  }
  
truncateText(text: string, limit: number = 30): string {
  if (!text) return '';
  return text.length > limit
    ? text.substring(0, limit) + '...'
    : text;
}

openUrlModal(content: any, url: string) {
  this.selectedUrl = url;
  this.modalService.open(content, {
    centered: true,
    size: 'lg'
  });
}

}
